import { createSelector } from '@mui/x-internals/store';
const selectRootState = state => state;
export const selectorChartZAxis = createSelector(selectRootState, state => state.zAxis);